import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export abstract class Unsubscribe implements OnDestroy {
  subscription: Subscription = new Subscription();

  public set sub(v: Subscription) {
    this.subscription.add(v);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
